import { type ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export type FilterBarProps = {
  children: ReactNode;
  onClear: () => void;
  clearTooltip?: string;
  extra?: ReactNode;
};

export const FilterBar = ({
  children,
  onClear,
  clearTooltip = 'Clear filters',
  extra,
}: FilterBarProps) => (
  <div className="flex flex-wrap items-center justify-end gap-1">
    {children}
    <Tooltip>
      <TooltipTrigger
        render={
          <Button variant="outline" size="icon" onClick={onClear}>
            <i className="pi pi-filter-slash text-sm" />
            <span className="sr-only">{clearTooltip}</span>
          </Button>
        }
      />
      <TooltipContent side="top">{clearTooltip}</TooltipContent>
    </Tooltip>
    {extra}
  </div>
);
